import { useCallback } from 'react'
import { isFormDataRequired } from '../../../../../lib/utils/collections'
import { Modal } from 'antd'
import { updateFormData, nextStage } from '../../../../store/claim/action-creators'
import { useAppDispatch } from '../../../../hooks/useAppDispatch/useAppDispatch'

export function useSaveResult() {
  const dispatch = useAppDispatch()
  const saveResult = useCallback(
    async (id, visibleFormData, stage, isNextStage = false) => {
      if (!visibleFormData) {
        return { error: null, data: null }
      }

      const formData = { ...visibleFormData.resultObject }
      if (visibleFormData?.workModalResult) {
        formData.work_modal = visibleFormData.workModalResult
      }

      if (isNextStage) {
        const isRequiredFields = isFormDataRequired(formData, visibleFormData.resultSchema)
        if (!isRequiredFields) {
          Modal.warning({
            title: 'Предупреждение',
            content: 'Заполните все обязательные поля',
          })
          return { error: 'required_fields', data: null }
        }
        return await dispatch(nextStage(id, { ...formData, stage }))
      } else {
        return await dispatch(updateFormData(id, formData))
      }
    },
    [dispatch],
  )
  return { saveResult }
}
